import { Injectable } from '@angular/core';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service'; 
import { CancelOrder, CancelOrderItem } from '../models/cancel-order.model';
import { RequestParams } from '../../../common/rest-api/models/request-params';
import { firstValueFrom } from 'rxjs';
import { StringUnitLength } from 'luxon';


@Injectable({
  providedIn: 'root',
})
export class CancelOrderService extends RestApiService<CancelOrder> {

  protected resourcePath = '/cancel-order';
  protected modelType = CancelOrder;


  async getForCustomer(customerId: string,params?:RequestParams): Promise<CancelOrder[]> {
     if(!params){
         params = new RequestParams();
        params.queryParams.params.CostCenterUser = "";
     }
    const url = this.buildEndpointUrl(`${customerId}`,params);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }

  
  async getSpecialCancelReport(customerId: string,params?:RequestParams): Promise<CancelOrder[]> {
     if(!params){
         params = new RequestParams();
     }
    const url = this.buildEndpointUrl(`special-cancel-report/${customerId}`,params);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
  async getAllCancelRecords(customerId: string,params?:RequestParams): Promise<CancelOrder[]> {
    if(!params){
         params = new RequestParams();
        params.queryParams.params.CostCenterUser = "";
     }
    const url = this.buildEndpointUrl(`all/${customerId}`,params);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }

  async getOpenCancelReport(customerId: string, userId:string): Promise<CancelOrderItem[]> {
    const url = this.buildEndpointUrl(`open-cancel-report/${customerId}/${userId}`);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrderItem[]>({
      url
    }, 'GET');

    return response;
  }
    async getWebReport(userId:string): Promise<any> {
      const originalResource = this.resourcePath;
      this.resourcePath = '';

      const url = this.buildEndpointUrl(`web-reports/get/${userId}`);

      this.resourcePath = originalResource;

    const response = await this.cloudApiMiddleware.cloudRequest<any>({
      url
    }, 'GET');

    return response;
  }
  
  async getForDepartment(departmentId: string, customerId: string,params?:RequestParams): Promise<CancelOrder[]> {
      
    if(!params){
            params = new RequestParams();
            params.queryParams.params.CostCenterUser = "";
        }
      const url = this.buildEndpointUrl(`${customerId}/${departmentId}`,params);
    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
async getForStopCode(customerId: string, stopCode:string,params?:RequestParams): Promise<CancelOrder[]> {
    if(!params){
         params = new RequestParams();
        params.queryParams.params.CostCenterUser = "";
     }

    const url = this.buildEndpointUrl(`stop/${customerId}/${stopCode}`,params);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
  async getForEmployee(employeeId: string, departmentId: string, customerId: string): Promise<CancelOrder[]> {
    
    const url = this.buildEndpointUrl(`${customerId}/${departmentId}/${employeeId}`);
    
    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
   async getForEmployeeCO(employeeId: string, departmentId: string, customerId: string,params?:RequestParams): Promise<CancelOrder[]> {
     if(!params){
         params = new RequestParams();
        params.queryParams.params.CostCenterUser = "";
     }
    const url = this.buildEndpointUrl(`get/${customerId}/${departmentId}/${employeeId}`,params);
    
    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
  async getForCostCenter(employeeId: string, departmentId: string, customerId: string,deliveryAddress2:StringUnitLength): Promise<CancelOrder[]> {
    const url = this.buildEndpointUrl(`${customerId}/${departmentId}/${employeeId}/${deliveryAddress2}`);
    
    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }

  async getForStop(stopCode: string): Promise<CancelOrder[]> {
    const url = this.buildEndpointUrl(`stop/${stopCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }

  async getNumberForStop(stopCode: string): Promise<number> {
    const url = this.buildEndpointUrl(`stop/${stopCode}/count`);

    const response = await this.cloudApiMiddleware.cloudRequest<number>({
      url
    }, 'GET');

    return response;
  }

  async updateCancelReport(cancelOrders: CancelOrder[]): Promise<CancelOrder[]> {
    const url = this.buildEndpointUrl(`cancel-report`);
   
    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url,
      body: cancelOrders
    }, 'PUT');
    
    return response;
  }
async getReturnReviewByCustomer(customerId: string): Promise<CancelOrder[]> {
   
    const url = this.buildEndpointUrl(`customer/${customerId}`);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
  async getReturnReviewByEmployee(custCode: string,deptCode:string,empCode:string): Promise<CancelOrder[]> {
   
    const url = this.buildEndpointUrl(`employee/${custCode}/${deptCode}/${empCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
  async getReturnReviewByDepartment(custCode: string,deptCode:string): Promise<CancelOrder[]> {
   
    const url = this.buildEndpointUrl(`department/${custCode}/${deptCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<CancelOrder[]>({
      url
    }, 'GET');

    return response;
  }
}